var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRoundedFilledCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 18,
    viewBox: "0 0 17 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.16678 16.4861C12.3012 16.4861 15.6529 13.1345 15.6529 9.00003C15.6529 4.86556 12.3012 1.51392 8.16678 1.51392C4.03231 1.51392 0.680664 4.86556 0.680664 9.00003C0.680664 13.1345 4.03231 16.4861 8.16678 16.4861ZM7.52467 12.0425L4.96334 9.48119L5.92579 8.51874L7.44779 10.0407L11.0528 5.83485L12.0863 6.72065L7.52467 12.0425Z",
    fill: "#0F973D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoundedFilledCheck);
export default __webpack_public_path__ + "static/media/rounded-filled-check.a446bbc6fbfdc7373ddf8a60898aa0bb.svg";
export { ForwardRef as ReactComponent };